import React, { useState } from "react";

// Asks for a Scenario Name before an unnamed scenario can be starred as the Go-To.
export function GoToNameDialog({ identifier, busy, error, onSubmit, onCancel }) {
  const [name, setName] = useState("");
  const trimmed = name.trim();
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center" style={{ background: "rgba(15,42,68,0.35)" }} data-testid="goto-name-dialog">
      <form
        onSubmit={(e) => { e.preventDefault(); if (trimmed && !busy) onSubmit(trimmed); }}
        className="bg-white w-[460px] max-w-[94vw] p-5 rounded-[5px]"
        style={{ border: "2px solid var(--u-coral)", boxShadow: "0 0 0 4px var(--u-navy), 0 20px 40px -12px rgba(0,0,0,0.3)" }}
      >
        <div className="font-display text-[18px] font-semibold" style={{ color: "#0F2A44" }}>Name this scenario</div>
        <div className="text-[13px] mt-1" style={{ color: "#33414A" }}>
          The Go-To scenario's name appears on the report cover. Give it a name to make it the Go-To.
        </div>
        <div className="text-[11px] text-slate mt-2 truncate" title={identifier}>{identifier}</div>
        <input
          autoFocus
          value={name}
          maxLength={56}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. 2027 Reserve Budget – 80% Target"
          className="mt-3 w-full border border-navy/40 rounded-[3px] px-2.5 py-2 text-[14px] focus:outline-none focus:border-navy"
          data-testid="goto-name-input"
        />
        <div className="text-[10.5px] text-slate mt-1 text-right">{name.length}/56</div>
        {error && <div className="text-[12px] text-coral mt-1" data-testid="goto-name-error">{error}</div>}
        <div className="flex justify-end gap-2 mt-3">
          <button type="button" onClick={onCancel} className="px-3 py-1.5 text-[13px] text-navy hover:bg-navy-wash rounded-[3px]" data-testid="goto-name-cancel">
            Cancel
          </button>
          <button type="submit" disabled={!trimmed || busy}
            className="px-3 py-1.5 text-[13px] font-semibold text-white bg-coral rounded-[3px] disabled:opacity-40 hover:opacity-90 transition-opacity"
            data-testid="goto-name-submit">
            {busy ? "Saving…" : "Save name & make Go-To"}
          </button>
        </div>
      </form>
    </div>
  );
}
